import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentWithText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 8h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M7 10c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1M8 14c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zM7 16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 22c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H8c-.27 0-.52.1-.71.29l-4 4a1.1 1.1 0 0 0-.214.33A1 1 0 0 0 3 7v14c0 .55.45 1 1 1zM5 8v12h14V4H9v3c0 .55-.45 1-1 1zm1.41-2H7v-.59z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocumentWithText;
